"use client";

import { useEffect, useState } from "react";
import plt_getPathList from "../libs/plt_getPathList";
import PAGE_INFO from "../constants/siteInfo/pageInfo";
import { SUB_PAGE_INFO_TYPE } from "../types/globalConstantsTypes";

const useGetPageTitleByPath = () => {
  const [currentPath, setCurrentPath] = useState("");
  
  useEffect(() => {
    setCurrentPath(decodeURIComponent(window.location.pathname))
    
  },[])
  
  const pathList = plt_getPathList(currentPath);
  const pageInfo = PAGE_INFO;

  let pageListForMenu: any = [];

  Object.keys(pageInfo).forEach((key) => {
    const isSlugContained = pathList.some(part => part.includes(pageInfo[key].SLUG));

    if (isSlugContained) {
      pageListForMenu.push({ title: pageInfo[key].TITLE, slug: pageInfo[key].SLUG, title_en: pageInfo[key].TITLE_EN, title_cover_class: pageInfo[key].TITLE_COVER_CLASS });

      // サブページがあるかどうかチェック
      const subPageInfo: SUB_PAGE_INFO_TYPE | undefined = pageInfo[key]?.SUB;

      if (subPageInfo) {
        const subPageList = Object.values(subPageInfo).map(subPage => ({
          title: subPage.TITLE,
          slug: subPage.SLUG,
          title_en: subPage.TITLE_EN,
          title_cover_class: subPage.TITLE_COVER_CLASS
        }));

        for (let i = 2; i < pathList.length; i++) {
          const subPathText = pathList.slice(1, i + 1).join("/");

          subPageList.forEach((subPage) => {
            if (subPage.slug == subPathText) {
              pageListForMenu.push({ title: subPage.title, slug: subPage.slug, title_en: subPage?.title_en, title_cover_class: subPage?.title_cover_class });
            }
          });
        }
      }
    }
  });
  return pageListForMenu[pageListForMenu.length - 1];
};


export default useGetPageTitleByPath;